'use client';

import { SavedViews } from '@savvy-kit/patterns/saved-views';

import type { SavedAccountFilter } from './hooks/use-saved-account-filters';

type SavedAccountFilterChipsProps = {
  readonly savedFilters: SavedAccountFilter[];
  readonly activeFilterId: string | null;
  readonly isModified: boolean;
  readonly onLoadPreset: (preset: SavedAccountFilter) => void;
  readonly onClearPreset: () => void;
  readonly onRename: (id: string, newName: string) => void;
  readonly onDelete: (id: string) => void;
};

export function SavedAccountFilterChips({
  savedFilters,
  activeFilterId,
  isModified,
  onLoadPreset,
  onClearPreset,
  onRename,
  onDelete,
}: SavedAccountFilterChipsProps) {
  return (
    <SavedViews
      savedViews={savedFilters}
      activeViewId={activeFilterId}
      isModified={isModified}
      onLoadView={onLoadPreset}
      onClearView={onClearPreset}
      onRenameView={onRename}
      onDeleteView={onDelete}
    />
  );
}
